import { FlickityPatched, type FlickityPatchedOptions } from "@sazka/utils/carousel/flickity-patched";
import { debounce } from "@sazka/utils/debounce";
import { documentReady } from "@sazka/utils/document-ready";

const selectors = {
    root: ".js-ticket-how-to-play-flickity",
    track: ".js-ticket-how-to-play-flickity-track",
    controls: ".js-ticket-how-to-play-flickity-controls",
    buttonPrev: ".js-ticket-how-to-play-flickity-button-prev",
    buttonNext: ".js-ticket-how-to-play-flickity-button-next",
};

let flickity: FlickityPatched = null;

const initTicketsHowToPlayFlickity = () => {
    const rootEl = document.querySelector(selectors.root) as HTMLElement;
    if (!rootEl) return;

    const controlsEl = rootEl.querySelector(selectors.controls) as HTMLElement;
    const prevButtonEl = rootEl.querySelector(selectors.buttonPrev) as HTMLElement;
    const nextButtonEl = rootEl.querySelector(selectors.buttonNext) as HTMLElement;

    const options: FlickityPatchedOptions = {
        prevNextButtons: false,
        groupCells: 1,
        cellAlign: "left",
        contain: true,
        cellSelector: ".ticket-how-to-play__item",
        imagesLoaded: true,
        draggable: !environment.isEditMode,
        dotsOptions: {
            rootEl: controlsEl,
            prev: prevButtonEl,
            next: nextButtonEl,
            useDsClasses: true,
        },
    };

    flickity = new FlickityPatched(rootEl, options);

    const disableButtons = () => {
        if (flickity.selectedIndex > 0) {
            prevButtonEl.classList.remove("disabled");
        } else {
            prevButtonEl.classList.add("disabled");
        }

        if (flickity.selectedIndex >= flickity.slides.length - 1) {
            nextButtonEl.classList.add("disabled");
        } else {
            nextButtonEl.classList.remove("disabled");
        }
    };

    prevButtonEl.addEventListener("click", () => flickity.previous());
    nextButtonEl.addEventListener("click", () => flickity.next());

    flickity.on("select", () => disableButtons());

    window.addEventListener(
        "resize",
        debounce(() => flickity.resize(), 200)
    );
};

documentReady(() => {
    initTicketsHowToPlayFlickity();

    if (environment.isEditMode) {
        let numberOfSlides = document.querySelectorAll(".ticket-how-to-play__item").length;
        const obs = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (!mutation.addedNodes.length) return;
                const newNumberOfSlides = document.querySelectorAll(".ticket-how-to-play__item").length;
                if (newNumberOfSlides === numberOfSlides) return;
                numberOfSlides = newNumberOfSlides;
                flickity?.destroy();
                flickity = null;
                initTicketsHowToPlayFlickity();

                // Wait for CMS rich text inicialization
                setTimeout(() => {
                    flickity.resize();
                }, 500);
            });
        });
        obs.observe(document.body, {
            attributes: false,
            childList: true,
            subtree: true,
        });
    }
});
